import { useState } from "react";
import { Share2, Copy, Check } from "lucide-react";
import { toast } from "sonner";

const POSITION_ORDER = ["Pour", "Contre", "Situation actuelle", "Résultat", "Synthèse"];

// Transforme le markdown de l'interprétation en texte élégant et lisible
const stripMarkdown = (md = "") =>
  md
    .replace(/^#{1,6}\s*/gm, "")           // titres
    .replace(/\*\*(.*?)\*\*/g, "$1")        // gras
    .replace(/\*(.*?)\*/g, "$1")            // italique
    .replace(/^\s*[-*]\s+/gm, "• ")         // puces
    .replace(/^\s*-{3,}\s*$/gm, "· · ·")    // séparateurs
    .replace(/\n{3,}/g, "\n\n")             // espaces multiples
    .trim();

const buildText = (reading) => {
  const cards = reading.cards || [];
  const ordered = POSITION_ORDER
    .map((pos) => cards.find((c) => c.position === pos))
    .filter(Boolean);
  const cardsList = (ordered.length ? ordered : cards)
    .map((c) => `• ${c.position} — ${c.name}`)
    .join("\n");

  return `✨ La Petite Boîte Intuitive ✨
Tarot de Marseille · Tirage en Croix

${reading.prenom}, au sujet de ${reading.prenom_autre}
« ${reading.question} »

— Ma Croix —
${cardsList}

— L'interprétation —
${stripMarkdown(reading.interpretation)}

lapetiteboiteintuitive.com`;
};

export const ShareReading = ({ reading, testid = "share-reading" }) => {
  const [copied, setCopied] = useState(false);
  const text = buildText(reading);

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: "Mon tirage · La Petite Boîte Intuitive", text });
      } else {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        toast.success("Ton tirage est copié — partage-le où tu veux.");
        setTimeout(() => setCopied(false), 2500);
      }
    } catch (e) {
      // partage annulé par l'utilisateur : rien à faire
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success("Ton tirage est copié — partage-le où tu veux.");
      setTimeout(() => setCopied(false), 2500);
    } catch (e) {
      toast.error("Copie impossible sur cet appareil.");
    }
  };

  return (
    <div className="w-full max-w-xl mt-10" data-testid={`${testid}-section`}>
      <span className="block mx-auto mb-6 h-px w-16" style={{ backgroundColor: "rgba(230,198,135,0.35)" }} />
      <p className="font-body text-sm leading-relaxed text-center mb-5" style={{ color: "#A2A2A6" }}>
        Ce tirage te parle ? Garde-le précieusement ou partage-le avec la personne de ton choix.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <button
          data-testid={testid}
          onClick={handleShare}
          className="inline-flex items-center gap-2 tracking-[0.12em] uppercase rounded-full px-7 py-3 font-body text-sm transition-opacity hover:opacity-90"
          style={{ backgroundColor: "#C5A059", color: "#1C1C1E" }}
        >
          <Share2 size={16} strokeWidth={1.6} />
          Partager mon tirage
        </button>
        <button
          data-testid={`${testid}-copy`}
          onClick={handleCopy}
          className="inline-flex items-center gap-2 tracking-[0.12em] uppercase rounded-full px-6 py-3 font-body text-sm transition-colors"
          style={{ border: "1px solid rgba(230,198,135,0.4)", color: copied ? "#E6C687" : "#A2A2A6" }}
        >
          {copied ? <Check size={16} strokeWidth={1.6} /> : <Copy size={16} strokeWidth={1.6} />}
          {copied ? "Copié" : "Copier le texte"}
        </button>
      </div>
    </div>
  );
};
